/**
 * Widget-local hook: fetches the current layer description for the selected layer.
 * This is used as the "Definition" text in the UI.
 */

import { useEffect, useState } from "react";

import APIHelper from "@giscon/utils.api-helper-esri";

const useLayerDescription = ({ layerurl }) => {
  const [description, setDescription] = useState("");

  useEffect(() => {
    let doNotSet = false;

    if (layerurl) {
      APIHelper.getLayerMeta(layerurl)
        .then(({ description }) => {
          if (!doNotSet) setDescription(description);
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.error("Error loading layer description:", e);
        });
    } else {
      setDescription("");
    }

    return () => {
      doNotSet = true;
    };
  }, [layerurl]);

  return { description };
};

export default useLayerDescription;
